module.exports = __webpack_public_path__ + "static/img/6.9621e4b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/zh/6.png
// module id = 3+cW
// module chunks = 0